"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefinedRolesWithPermissions = exports.permissionDescriptions = exports.Permission = exports.FeatureFlagRole = exports.Role = void 0;
/**
 * Roles to categorize Users and allow to easily assign permissions.
 * These roles are also used in the UI, for example when creating or updating users.
 */
var Role;
(function (Role) {
    Role["WaveAdmin"] = "WaveAdmin";
    Role["Owner"] = "Owner";
    Role["Admin"] = "Admin";
    Role["Operator"] = "Operator";
    Role["Developer"] = "Developer";
    Role["Guest"] = "Guest";
    Role["Mfa"] = "Mfa";
    Role["Installer"] = "Installer";
})(Role || (exports.Role = Role = {}));
/**
 * "Invisible" roles that are only used to assign feature flags.
 * They are not used anywhere in the UI.
 */
var FeatureFlagRole;
(function (FeatureFlagRole) {
    FeatureFlagRole["Staff"] = "Staff";
    FeatureFlagRole["Stakeholder"] = "Stakeholder";
    FeatureFlagRole["Tester"] = "Tester";
    FeatureFlagRole["CsaEarlyAccess"] = "csa-early-access";
})(FeatureFlagRole || (exports.FeatureFlagRole = FeatureFlagRole = {}));
var Permission;
(function (Permission) {
    Permission["AlertResolve"] = "alert:resolve";
    Permission["AlertView"] = "alert:view";
    Permission["ApiKeyCreate"] = "apikey:create";
    Permission["ApiKeyDelete"] = "apikey:delete";
    Permission["ApiKeyView"] = "apikey:view";
    Permission["AppInstall"] = "app:install";
    Permission["AppUninstall"] = "app:uninstall";
    Permission["AppView"] = "app:view";
    Permission["CustomerCreate"] = "customer:create";
    Permission["CustomerDelete"] = "customer:delete";
    Permission["CustomerUpdate"] = "customer:update";
    Permission["CustomerView"] = "customer:view";
    Permission["DisplayAliasUpdate"] = "display:alias:update";
    Permission["DisplayClaim"] = "display:claim";
    Permission["DisplayContentCreate"] = "display:content:create";
    Permission["DisplayContentDelete"] = "display:content:delete";
    Permission["DisplayContentUpdate"] = "display:content:update";
    Permission["DisplayContentView"] = "display:content:view";
    Permission["DisplayFirmwareUpdate"] = "display:firmware:update";
    Permission["DisplayGroupAssign"] = "display:group:assign";
    Permission["DisplayGroupUnassign"] = "display:group:unassign";
    Permission["DisplayRecommendedPowerSettingsUpdate"] = "display:recommended:power:update";
    Permission["DisplayRecommendedSettingsUpdate"] = "display:recommended:settings:update";
    Permission["DisplayScreenshotCreate"] = "display:screenshot:create";
    Permission["DisplaySettingsUpdate"] = "display:settings:update";
    Permission["DisplaySettingsView"] = "display:settings:view";
    Permission["DisplaySiteUpdate"] = "display:site:update";
    Permission["DisplayTimeZoneUpdate"] = "display:timezone:update";
    Permission["DisplayUnclaim"] = "display:unclaim";
    Permission["DisplayView"] = "display:view";
    Permission["FeatureCustomerScopedAccess"] = "feature:customer:scoped:access";
    Permission["FeatureStaff"] = "feature:staff";
    Permission["FeatureStakeholder"] = "feature:stakeholder";
    Permission["FirmwareRelease"] = "firmware:release";
    Permission["GroupCreate"] = "group:create";
    Permission["GroupView"] = "group:view";
    Permission["OrganizationCreate"] = "organization:create";
    Permission["OrganizationDelete"] = "organization:delete";
    Permission["OrganizationUpdate"] = "organization:update";
    Permission["OrganizationView"] = "organization:view";
    Permission["PlatformView"] = "platform:view";
    Permission["PlaylistCreate"] = "playlist:create";
    Permission["PlaylistDelete"] = "playlist:delete";
    Permission["PlaylistUpdate"] = "playlist:update";
    Permission["PlaylistView"] = "playlist:view";
    Permission["PowerscheduleCreate"] = "powerschedule:create";
    Permission["PowerscheduleDelete"] = "powerschedule:delete";
    Permission["PowerscheduleUpdate"] = "powerschedule:update";
    Permission["PowerscheduleView"] = "powerschedule:view";
    Permission["SiteCreate"] = "site:create";
    Permission["SiteDelete"] = "site:delete";
    Permission["SiteUpdate"] = "site:update";
    Permission["SiteView"] = "site:view";
    Permission["UserCreate"] = "user:create";
    Permission["UserDelete"] = "user:delete";
    Permission["UserUpdate"] = "user:update";
    Permission["UserView"] = "user:view";
    Permission["WaveSubscriptionView"] = "waveSubscription:view";
    Permission["WaveSubscriptionUpdate"] = "waveSubscription:update";
})(Permission || (exports.Permission = Permission = {}));
exports.permissionDescriptions = {
    [Permission.AlertResolve]: 'Permission to resolve display alerts',
    [Permission.AlertView]: 'Permission to view display alerts',
    [Permission.ApiKeyCreate]: 'Permission to create api keys',
    [Permission.ApiKeyDelete]: 'Permission to delete api keys',
    [Permission.ApiKeyView]: 'Permission to view api keys',
    [Permission.AppInstall]: 'Permission to install apps',
    [Permission.AppUninstall]: 'Permission to uninstall apps',
    [Permission.AppView]: 'Permission to view apps',
    [Permission.CustomerCreate]: 'Permission to create customers',
    [Permission.CustomerDelete]: 'Permission to delete customers',
    [Permission.CustomerUpdate]: 'Permission to update customers',
    [Permission.CustomerView]: 'Permission to view customers',
    [Permission.DisplayClaim]: 'Permission to claim displays',
    [Permission.DisplayContentCreate]: 'Permission to create display content',
    [Permission.DisplayContentDelete]: 'Permission to delete display content',
    [Permission.DisplayContentUpdate]: 'Permission to update display content',
    [Permission.DisplayContentView]: 'Permission to view display content',
    [Permission.DisplayFirmwareUpdate]: "Permission to update a display's firmware",
    [Permission.DisplayScreenshotCreate]: 'Permission to create screenshots on a display',
    [Permission.DisplaySettingsUpdate]: "Permission to update a display's settings",
    [Permission.DisplaySettingsView]: "Permission to view a display's settings",
    [Permission.DisplayUnclaim]: 'Permission to unclaim displays',
    [Permission.DisplayView]: 'Permission to view displays',
    [Permission.FirmwareRelease]: 'Permission to release firmware',
    [Permission.GroupCreate]: 'Permission to create groups',
    [Permission.GroupView]: 'Permission to view groups',
    [Permission.OrganizationCreate]: 'Permission to create organizations',
    [Permission.OrganizationDelete]: 'Permission to delete organizations',
    [Permission.OrganizationUpdate]: 'Permission to update organizations',
    [Permission.OrganizationView]: 'Permission to view organizations',
    [Permission.PlatformView]: 'Permission to view platform',
    [Permission.PlaylistCreate]: 'Permission to create playlists',
    [Permission.PlaylistDelete]: 'Permission to delete playlists',
    [Permission.PlaylistUpdate]: 'Permission to update playlists',
    [Permission.PlaylistView]: 'Permission to view playlists',
    [Permission.PowerscheduleCreate]: 'Permission to create power schedules',
    [Permission.PowerscheduleDelete]: 'Permission to delete power schedules',
    [Permission.PowerscheduleUpdate]: 'Permission to update power schedules',
    [Permission.PowerscheduleView]: 'Permission to view power schedules',
    [Permission.SiteCreate]: 'Permission to create sites',
    [Permission.SiteDelete]: 'Permission to delete sites',
    [Permission.SiteUpdate]: 'Permission to update sites',
    [Permission.SiteView]: 'Permission to view sites',
    [Permission.UserCreate]: 'Permission to create users',
    [Permission.UserDelete]: 'Permission to delete users',
    [Permission.UserUpdate]: 'Permission to update users',
    [Permission.UserView]: 'Permission to view users',
    [Permission.WaveSubscriptionView]: 'Permission to view Wave subscriptions',
    [Permission.WaveSubscriptionUpdate]: 'Permission to update Wave subscriptions',
    // Granular permissions
    [Permission.DisplayAliasUpdate]: 'Permission to update an alias to a display',
    [Permission.DisplayGroupAssign]: 'Permission to add a group to a display',
    [Permission.DisplayGroupUnassign]: 'Permission to remove a group from a display',
    [Permission.DisplayRecommendedPowerSettingsUpdate]: 'Permission to apply the recommended power settings for a display',
    [Permission.DisplayRecommendedSettingsUpdate]: 'Permission to apply the recommended settings for a display',
    [Permission.DisplaySiteUpdate]: 'Permission to update the site of a display',
    [Permission.DisplayTimeZoneUpdate]: 'Permission to updated the timezone of a display',
    // Feature flags
    [Permission.FeatureCustomerScopedAccess]: 'Permission to access assign customer scoped access to users',
    [Permission.FeatureStaff]: 'Permission containing the Staff feature flag',
    [Permission.FeatureStakeholder]: 'Permission containing the Stakeholder feature flag',
};
function getDefinedRolesWithPermissions() {
    return {
        [FeatureFlagRole.Staff]: [Permission.FeatureCustomerScopedAccess, Permission.FeatureStaff],
        [FeatureFlagRole.Stakeholder]: [
            Permission.FeatureStakeholder,
            Permission.FeatureCustomerScopedAccess,
        ],
        [FeatureFlagRole.Tester]: [Permission.FeatureCustomerScopedAccess],
        [FeatureFlagRole.CsaEarlyAccess]: [Permission.FeatureCustomerScopedAccess],
        [Role.WaveAdmin]: [
            Permission.AlertView,
            Permission.AlertResolve,
            Permission.ApiKeyView,
            Permission.ApiKeyCreate,
            Permission.ApiKeyDelete,
            Permission.AppView,
            Permission.AppInstall,
            Permission.AppUninstall,
            Permission.CustomerView,
            Permission.CustomerCreate,
            Permission.CustomerUpdate,
            Permission.CustomerDelete,
            Permission.FirmwareRelease,
            Permission.PlatformView,
            Permission.PlaylistView,
            Permission.PlaylistCreate,
            Permission.PlaylistUpdate,
            Permission.PlaylistDelete,
            Permission.PowerscheduleView,
            Permission.PowerscheduleCreate,
            Permission.PowerscheduleUpdate,
            Permission.PowerscheduleDelete,
            Permission.SiteView,
            Permission.SiteCreate,
            Permission.SiteUpdate,
            Permission.SiteDelete,
            Permission.GroupView,
            Permission.GroupCreate,
            Permission.DisplayView,
            Permission.DisplayClaim,
            Permission.DisplayUnclaim,
            Permission.DisplayContentView,
            Permission.DisplayContentCreate,
            Permission.DisplayContentUpdate,
            Permission.DisplayContentDelete,
            Permission.DisplayFirmwareUpdate,
            Permission.DisplayScreenshotCreate,
            Permission.DisplaySettingsView,
            Permission.DisplaySettingsUpdate,
            Permission.OrganizationCreate,
            Permission.OrganizationDelete,
            Permission.OrganizationUpdate,
            Permission.OrganizationView,
            Permission.UserView,
            Permission.UserCreate,
            Permission.UserUpdate,
            Permission.UserDelete,
            Permission.WaveSubscriptionView,
            Permission.WaveSubscriptionUpdate,
            // Granular permissions
            Permission.DisplayAliasUpdate,
            Permission.DisplayGroupAssign,
            Permission.DisplayGroupUnassign,
            Permission.DisplayRecommendedPowerSettingsUpdate,
            Permission.DisplayRecommendedSettingsUpdate,
            Permission.DisplaySiteUpdate,
            Permission.DisplayTimeZoneUpdate,
        ],
        [Role.Owner]: [
            Permission.AlertView,
            Permission.AlertResolve,
            Permission.ApiKeyView,
            Permission.ApiKeyCreate,
            Permission.ApiKeyDelete,
            Permission.AppView,
            Permission.AppInstall,
            Permission.AppUninstall,
            Permission.CustomerView,
            Permission.CustomerCreate,
            Permission.CustomerUpdate,
            Permission.CustomerDelete,
            Permission.FeatureCustomerScopedAccess,
            Permission.PlaylistView,
            Permission.PlaylistCreate,
            Permission.PlaylistUpdate,
            Permission.PlaylistDelete,
            Permission.PowerscheduleView,
            Permission.PowerscheduleCreate,
            Permission.PowerscheduleUpdate,
            Permission.PowerscheduleDelete,
            Permission.SiteView,
            Permission.SiteCreate,
            Permission.SiteUpdate,
            Permission.SiteDelete,
            Permission.GroupView,
            Permission.GroupCreate,
            Permission.DisplayView,
            Permission.DisplayClaim,
            Permission.DisplayUnclaim,
            Permission.DisplayContentView,
            Permission.DisplayContentCreate,
            Permission.DisplayContentUpdate,
            Permission.DisplayContentDelete,
            Permission.DisplayFirmwareUpdate,
            Permission.DisplayScreenshotCreate,
            Permission.DisplaySettingsView,
            Permission.DisplaySettingsUpdate,
            Permission.OrganizationUpdate,
            Permission.OrganizationView,
            Permission.UserView,
            Permission.UserCreate,
            Permission.UserUpdate,
            Permission.UserDelete,
            Permission.WaveSubscriptionView,
            Permission.WaveSubscriptionUpdate,
            // Granular permissions
            Permission.DisplayAliasUpdate,
            Permission.DisplayGroupAssign,
            Permission.DisplayGroupUnassign,
            Permission.DisplayRecommendedPowerSettingsUpdate,
            Permission.DisplayRecommendedSettingsUpdate,
            Permission.DisplaySiteUpdate,
            Permission.DisplayTimeZoneUpdate,
        ],
        [Role.Admin]: [
            Permission.AlertView,
            Permission.AlertResolve,
            Permission.ApiKeyView,
            Permission.ApiKeyCreate,
            Permission.ApiKeyDelete,
            Permission.AppView,
            Permission.AppInstall,
            Permission.AppUninstall,
            Permission.CustomerView,
            Permission.CustomerCreate,
            Permission.CustomerUpdate,
            Permission.CustomerDelete,
            Permission.FeatureCustomerScopedAccess,
            Permission.PlaylistView,
            Permission.PlaylistCreate,
            Permission.PlaylistUpdate,
            Permission.PlaylistDelete,
            Permission.PowerscheduleView,
            Permission.PowerscheduleCreate,
            Permission.PowerscheduleUpdate,
            Permission.PowerscheduleDelete,
            Permission.SiteView,
            Permission.SiteCreate,
            Permission.SiteUpdate,
            Permission.SiteDelete,
            Permission.GroupView,
            Permission.GroupCreate,
            Permission.DisplayView,
            Permission.DisplayClaim,
            Permission.DisplayUnclaim,
            Permission.DisplayContentView,
            Permission.DisplayContentCreate,
            Permission.DisplayContentUpdate,
            Permission.DisplayContentDelete,
            Permission.DisplayFirmwareUpdate,
            Permission.DisplayScreenshotCreate,
            Permission.DisplaySettingsView,
            Permission.DisplaySettingsUpdate,
            Permission.OrganizationUpdate,
            Permission.OrganizationView,
            Permission.UserView,
            Permission.UserCreate,
            Permission.UserUpdate,
            Permission.UserDelete,
            Permission.WaveSubscriptionView,
            Permission.WaveSubscriptionUpdate,
            // Granular permissions
            Permission.DisplayAliasUpdate,
            Permission.DisplayGroupAssign,
            Permission.DisplayGroupUnassign,
            Permission.DisplayRecommendedPowerSettingsUpdate,
            Permission.DisplayRecommendedSettingsUpdate,
            Permission.DisplaySiteUpdate,
            Permission.DisplayTimeZoneUpdate,
        ],
        [Role.Developer]: [
            Permission.AlertView,
            Permission.AlertResolve,
            Permission.ApiKeyView,
            Permission.ApiKeyCreate,
            Permission.ApiKeyDelete,
            Permission.AppView,
            Permission.AppInstall,
            Permission.AppUninstall,
            Permission.CustomerView,
            Permission.PlaylistView,
            Permission.PowerscheduleView,
            Permission.SiteView,
            Permission.GroupView,
            Permission.DisplayView,
            Permission.DisplayContentView,
            Permission.DisplayContentCreate,
            Permission.DisplayContentUpdate,
            Permission.DisplayContentDelete,
            Permission.DisplayScreenshotCreate,
            Permission.DisplaySettingsView,
            Permission.OrganizationView,
            Permission.UserView,
        ],
        [Role.Operator]: [
            Permission.AlertView,
            Permission.AlertResolve,
            Permission.AppView,
            Permission.AppInstall,
            Permission.AppUninstall,
            Permission.CustomerView,
            Permission.PlaylistView,
            Permission.PlaylistCreate,
            Permission.PlaylistUpdate,
            Permission.PlaylistDelete,
            Permission.PowerscheduleView,
            Permission.PowerscheduleCreate,
            Permission.PowerscheduleUpdate,
            Permission.PowerscheduleDelete,
            Permission.SiteView,
            Permission.SiteCreate,
            Permission.SiteUpdate,
            Permission.SiteDelete,
            Permission.GroupView,
            Permission.GroupCreate,
            Permission.DisplayView,
            Permission.DisplayContentView,
            Permission.DisplayContentUpdate,
            Permission.DisplayContentDelete,
            Permission.DisplayFirmwareUpdate,
            Permission.DisplayScreenshotCreate,
            Permission.DisplaySettingsView,
            Permission.DisplaySettingsUpdate,
            Permission.OrganizationView,
            // Granular permissions
            Permission.DisplayAliasUpdate,
            Permission.DisplayGroupAssign,
            Permission.DisplayGroupUnassign,
            Permission.DisplayRecommendedPowerSettingsUpdate,
            Permission.DisplayRecommendedSettingsUpdate,
            Permission.DisplaySiteUpdate,
            Permission.DisplayTimeZoneUpdate,
        ],
        [Role.Guest]: [
            Permission.AlertView,
            Permission.AppView,
            Permission.CustomerView,
            Permission.PlaylistView,
            Permission.PowerscheduleView,
            Permission.SiteView,
            Permission.GroupView,
            Permission.DisplayView,
            Permission.DisplayContentView,
            Permission.OrganizationView,
        ],
        [Role.Mfa]: [Permission.DisplayView],
        [Role.Installer]: [
            Permission.AlertView,
            Permission.AppView,
            Permission.CustomerView,
            Permission.PlaylistView,
            Permission.PowerscheduleView,
            Permission.SiteView,
            Permission.GroupView,
            Permission.DisplayView,
            Permission.DisplayContentView,
            Permission.OrganizationView,
            Permission.DisplayClaim,
            Permission.DisplayUnclaim,
            // Granular permissions
            Permission.DisplayAliasUpdate,
            Permission.DisplayRecommendedPowerSettingsUpdate,
            Permission.DisplayRecommendedSettingsUpdate,
            Permission.DisplaySiteUpdate,
            Permission.DisplayTimeZoneUpdate,
        ],
    };
}
exports.getDefinedRolesWithPermissions = getDefinedRolesWithPermissions;
